import { useCallback } from "react";
import {
  IRemoveQuickPinByIdAction,
  RegistryLayoutStoreActions,
  useRegistryLayoutDispatch,
} from "../useRegistryLayoutStore";

export const useRemoveQuickPinById = (): ((
  payload: IRemoveQuickPinByIdAction
) => void) => {
  const dispatch = useRegistryLayoutDispatch();

  const removeQuickPinById = useCallback(
    (payload: IRemoveQuickPinByIdAction) => {
      dispatch({
        type: RegistryLayoutStoreActions.removeQuickPinById,
        payload,
      });
    },
    [dispatch]
  );

  return removeQuickPinById;
};
